import { SupportedLocale } from './translations.cnst'

export const localeToRatingTextMap: Record<SupportedLocale, string> = {
  [SupportedLocale.svSE]: '57,7k betyg i App Store',
  [SupportedLocale.enUS]: '57.7K+ ratings in the App Store',
  [SupportedLocale.ptBR]: '57,7k avaliações na App Store',
  [SupportedLocale.esUS]: '57,7k valoraciones en la App Store',
  [SupportedLocale.enCA]: '57,7k ratings in the App Store',
}
